import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=0f71d506&scoped=true&"
import script from "./EventList.vue?vue&type=script&lang=js&"
export * from "./EventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f71d506",
  null
  
)

export default component.exports